export const amountRange = [
  '$0-$24,999',
  '$25,000-$49,999',
  '$50,000-$74,999',
  '$75,000-$99,999',
  '$100,000-$124,999',
  '$125,000-$149,999',
  '$150,000-$174,999',
  '$175,000-$199,999',
  '$200,000-$224,999',
  '$225,000-$249,999',
  '$250,000-$299,999',
  '$300,000-$399,999',
  '$400,000-$499,999',
  '$500,000-$749,999',
  '$750,000-$999,999',
  '$1,000,000-$4,999,999',
  '$5,000,000+',
];

export const incomeRange = [
  '$0-$24,999',
  '$25,000-$49,999',
  '$50,000-$74,999',
  '$75,000-$99,999',
  '$100,000-$124,999',
  '$125,000-$149,999',
  '$150,000-$174,999',
  '$175,000-$199,999',
  '$200,000-$224,999',
  '$225,000-$249,999',
  '$250,000-$299,999',
  '$300,000+',
];

export const nonRetirementSavingsRange = [
  '$0-$24,999',
  '$25,000-$49,999',
  '$50,000-$74,999',
  '$75,000-$99,999',
  '$100,000-$124,999',
  '$125,000-$149,999',
  '$150,000-$174,999',
  '$175,000-$199,999',
  '$200,000-$224,999',
  '$225,000-$249,999',
  '$250,000-$299,999',
  '$300,000+',
];

export const retirementSavingsRange = [
  '$0-$24,999',
  '$25,000-$49,999',
  '$50,000-$74,999',
  '$75,000-$99,999',
  '$100,000-$124,999',
  '$125,000-$149,999',
  '$150,000-$174,999',
  '$175,000-$199,999',
  '$200,000-$224,999',
  '$225,000-$249,999',
  '$250,000-$299,999',
  '$300,000-$399,999',
  '$400,000-$499,999',
  '$500,000-$749,999',
  '$750,000-$999,999',
  '$1,000,000-$4,999,999',
  '$5,000,000+',
];

export const homeAndMortgageRange = [
  '$1-$24,999',
  '$25,000-$49,999',
  '$50,000-$74,999',
  '$75,000-$99,999',
  '$100,000-$124,999',
  '$125,000-$149,999',
  '$150,000-$174,999',
  '$175,000-$199,999',
  '$200,000-$224,999',
  '$225,000-$249,999',
  '$250,000-$274,999',
  '$275,000-$299,999',
  '$300,000-$324,999',
  '$325,000-$349,999',
  '$350,000-$374,999',
  '$375,000-$399,999',
  '$400,000-$424,999',
  '$425,000-$449,999',
  '$450,000-$474,999',
  '$475,000-$499,999',
  '$500,000-$749,999',
  '$750,000-$999,999',
  '$1,000,000-$4,999,999',
  '$5,000,000+',
];
